import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Error", -1 /* HOISTED */)
const _hoisted_4 = { class: "font-size-xl mb-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There was problem while loading the referral. Please try again. ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("template", { else: "" }, [
  /*#__PURE__*/_createTextVNode(" There was problem while generating the referral form. Please try again. ")
], -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode(" If the problem persists, "),
  /*#__PURE__*/_createCommentVNode("<report-error-link>Click here</report-error-link>"),
  /*#__PURE__*/_createTextVNode(" Click here to report it. ")
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl" }, "Loading Referral Form...", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl text-center" }, "Saving Referral...", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  id: "Homecare_New_Referral"
}
const _hoisted_17 = { class: "convert-header mb-1" }
const _hoisted_18 = { class: "card mx-2 mb-4" }
const _hoisted_19 = { class: "card-body form-content p-3 mx-lg-6" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("section", { class: "d-flex flex-column px-3 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, " Emergency Contacts can be added to the referral after it has been created. ")
], -1 /* HOISTED */)
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex justify-content-center form-footer gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralSourceInformation = _resolveComponent("ReferralSourceInformation")!
  const _component_DemographicsInformation = _resolveComponent("DemographicsInformation")!
  const _component_ServicesRequired = _resolveComponent("ServicesRequired")!
  const _component_CreateDmeNeeded = _resolveComponent("CreateDmeNeeded")!
  const _component_EditDmeNeeded = _resolveComponent("EditDmeNeeded")!
  const _component_CreatePhysician = _resolveComponent("CreatePhysician")!
  const _component_EditPhysician = _resolveComponent("EditPhysician")!
  const _component_EmergencyContactsSection = _resolveComponent("EmergencyContactsSection")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_ReferralComments = _resolveComponent("ReferralComments")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "content-class": "p-0",
    "has-page-scroll": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoadError || _ctx.isFormLoading || _ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.isLoadError && !_ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, [
                    (_ctx.referralId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_5
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _hoisted_6
                  ]),
                  _hoisted_7,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadReferral()))
                  }, "Try Again")
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoadError && _ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
              : _createCommentVNode("v-if", true),
            (_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(`Edit Home Care Referral-${_ctx.formatName(_ctx.referral.firstName, _ctx.referral.lastName)}`), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_ReferralSourceInformation, {
                    referral: _ctx.referral,
                    onUpdateReferralSource: _ctx.updateReferralSource,
                    onUpdateReferralDetails: _ctx.updateReferralDetails,
                    "referral-details-validation": _ctx.referralDetailsValidation,
                    "referral-source-validation": _ctx.referralSourceValidation,
                    ref: "referralSource"
                  }, null, 8 /* PROPS */, ["referral", "onUpdateReferralSource", "onUpdateReferralDetails", "referral-details-validation", "referral-source-validation"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_DemographicsInformation, {
                    referral: _ctx.referral,
                    accountId: _ctx.externalReferralAccountId,
                    providerId: _ctx.providerId,
                    branchId: _ctx.branchId,
                    checkPhoneValidation: _ctx.checkPhoneValidation,
                    isEdit: _ctx.isCreate ? false : true,
                    ref: "demographic"
                  }, null, 8 /* PROPS */, ["referral", "accountId", "providerId", "branchId", "checkPhoneValidation", "isEdit"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ServicesRequired, {
                    referral: _ctx.referral,
                    accountId: _ctx.externalReferralAccountId,
                    onUpdateHasOtherServicesRequired: _ctx.updateHasOtherServicesRequired,
                    onUpdateNonMedicalServicesRequiredCollection: 
                                        _ctx.updateNonMedicalServicesRequiredCollection
                                    ,
                    onUpdateServicesRequiredCollection: _ctx.updateServicesRequiredCollection
                  }, null, 8 /* PROPS */, ["referral", "accountId", "onUpdateHasOtherServicesRequired", "onUpdateNonMedicalServicesRequiredCollection", "onUpdateServicesRequiredCollection"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (!_ctx.referral.isNonMedical)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isCreate)
                          ? (_openBlock(), _createBlock(_component_CreateDmeNeeded, {
                              key: 0,
                              referral: _ctx.referral
                            }, null, 8 /* PROPS */, ["referral"]))
                          : (_openBlock(), _createBlock(_component_EditDmeNeeded, {
                              key: 1,
                              referral: _ctx.referral,
                              "patient-id": _ctx.referral.id
                            }, null, 8 /* PROPS */, ["referral", "patient-id"]))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (!_ctx.referral.isNonMedical)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isCreate)
                          ? (_openBlock(), _createBlock(_component_CreatePhysician, {
                              key: 0,
                              referral: _ctx.referral
                            }, null, 8 /* PROPS */, ["referral"]))
                          : (_openBlock(), _createBlock(_component_EditPhysician, {
                              key: 1,
                              referral: _ctx.referral,
                              "referral-id": _ctx.referral.id
                            }, null, 8 /* PROPS */, ["referral", "referral-id"]))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (!_ctx.isCreate)
                    ? (_openBlock(), _createBlock(_component_EmergencyContactsSection, {
                        key: 0,
                        referral: _ctx.referral,
                        "patient-id": _ctx.referral.id,
                        application: _ctx.referral.application,
                        "account-id": _ctx.referral.accountId,
                        "patient-primary-address": _ctx.referral.primaryAddress
                      }, null, 8 /* PROPS */, ["referral", "patient-id", "application", "account-id", "patient-primary-address"]))
                    : (_openBlock(), _createBlock(_component_FormSection, {
                        key: 1,
                        title: "Emergency Contacts",
                        "full-height": false,
                        "application-id": _ctx.referral.application
                      }, {
                        content: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["application-id"]))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ReferralComments, { referral: _ctx.referral }, null, 8 /* PROPS */, ["referral"])
                ])
              ])
            ]),
            (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_28, [
                  (!_ctx.isCreate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary me-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update()))
                      }, " Save Referral "))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isCreate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary me-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.create()))
                      }, " Create Referral "))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary me-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToReferralList()))
                  }, " View Referral List "),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToReferralList(true)))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}